<!-- Header -->
<div class="modal-header">
  <h4 class="modal-title pull-left">Report Link</h4>
  <div aria-label="Close" (click)="onCancel()" class="close pull-right">
    <span aria-hidden="true">×</span></div>
</div>

<!-- Container -->
<div class="modal-body">
  <crm-alert #alert></crm-alert>
  <div class="row report-link-search">
    <div class="col-sm-12">
      <label class="rbv-label">Search Reports</label>
      <input-search [provider]="linkedReportProvider" [inputValue]="selectedReport"
        [typeOverride]="SystemType.ALL" placeholder="Select Report to Link"
        (valueChange)="onSelected($event)" [linkReportType]="true" [displayFull]="true"></input-search>
    </div>
  </div>
</div>

<!-- Action Button -->
<div class="modal-footer">
  <button class="btn btn-rbv default" (click)="onCancel()">Cancel</button>
  <button class="btn btn-rbv warning" [disabled]="!selectedReport" (click)="onConfirm()">Link</button>
</div>
